import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/** Grup adı düzenleme şeması (122): nameTr zorunlu, nameEn opsiyonel. */
export const groupFormSchema = z.object({
  nameTr: requiredText(),
  nameEn: optionalText(),
})

export type GroupFormValues = z.infer<typeof groupFormSchema>
